var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "empty_check",
    transform: "translate(-465 -2354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2796",
    "data-name": "Rectangle 2796",
    transform: "translate(465 2354)",
    fill: "none",
    stroke: "#dc3a1a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tick",
    transform: "translate(471 2294.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2022",
    "data-name": "Group 2022",
    transform: "translate(0 67.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8461",
    "data-name": "Path 8461",
    d: "M15.765,68.232a.8.8,0,0,0-1.131,0L5.049,77.816,1.365,74.132A.8.8,0,0,0,.234,75.264l4.25,4.25a.8.8,0,0,0,1.131,0l10.15-10.15a.8.8,0,0,0,0-1.132Z",
    transform: "translate(0 -67.998)",
    fill: "#dc3a1a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCheck);
export default __webpack_public_path__ + "static/media/empty_check.19ffb64336d0c418f9627681e991422e.svg";
export { ForwardRef as ReactComponent };